import React, { useState } from "react";
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody,
  ModalFooter, Button, FormControl, FormLabel, Input, VStack, useToast,
} from "@chakra-ui/react";
import { criarCrmContato } from "../../services/api";
import { soDigitos } from "./crmUtils";

const ACCENT = "#F68633";

export default function NovoContatoModal({ isOpen, onClose, onCriado }) {
  const [nome, setNome] = useState("");
  const [telefone, setTelefone] = useState("");
  const [salvando, setSalvando] = useState(false);
  const toast = useToast();

  const salvar = async () => {
    if (soDigitos(telefone).length < 10) {
      toast({ status: "warning", title: "Telefone inválido", description: "Inclua DDD." });
      return;
    }
    setSalvando(true);
    const r = await criarCrmContato({ telefone, nome, origem: "manual" });
    setSalvando(false);
    if (r?.data?.id) {
      toast({ status: "success", title: "Contato criado" });
      setNome(""); setTelefone("");
      onCriado?.(r.data.id);
      onClose();
    } else {
      toast({ status: "error", title: "Erro", description: r?.error || "Não foi possível criar." });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Novo contato</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4}>
            <FormControl>
              <FormLabel fontSize="sm">Nome</FormLabel>
              <Input value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Nome do cliente" />
            </FormControl>
            <FormControl isRequired>
              <FormLabel fontSize="sm">Telefone (com DDD)</FormLabel>
              <Input
                value={telefone}
                onChange={(e) => setTelefone(e.target.value)}
                placeholder="11 99999-9999"
                onKeyDown={(e) => e.key === "Enter" && salvar()}
              />
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>Cancelar</Button>
          <Button bg={ACCENT} color="white" _hover={{ bg: "#d4702a" }} onClick={salvar} isLoading={salvando}>
            Criar e abrir
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
